module.exports = __webpack_public_path__ + "img/counter-icon-1.a74ea15b.svg";